import React from 'react';
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap';
import { FaTimes, FaArrowCircleRight, FaArrowCircleLeft } from 'react-icons/fa';

import ReactPlayer from 'react-player';

import {
  GET_OBJECT_DOWNLOAD,
  GET_OBJECT_DOWNLOAD_SUCCESS,
  GET_OBJECT_DOWNLOAD_FAILURE
} from 'constants/ActionTypes'

import extensions from 'constants/extensions'

import Button from "components/Button";

import './preview.css'

class Preview extends React.Component {
  state = {
    error: false,
    loading: true,
    preview: null,
    numPages: null,
    pageNumber: 1,
  };

  componentWillReceiveProps(nextProps) {
    switch (nextProps.type) {
      case GET_OBJECT_DOWNLOAD:
        this.setState({ preview: null, loading: true });
        break;
      case GET_OBJECT_DOWNLOAD_SUCCESS:
        this.setState({ preview: nextProps.preview });
        break;
      case GET_OBJECT_DOWNLOAD_FAILURE:
        this.setState({ preview: null, error: true, loading: false });
        break;
    }
  }

  renderPreview = (file, lightTheme) => {
    let component = null;

    if (file) {
      let ext = file.item.split('.').pop();

      if (this.isImage(ext)) {
        component = (
          <img src={`${file.downloadUrl}`} className='preview-image' />
        );

        if (this.state.loading) {
          this.setState({ loading: false });
        }
      } else if (this.isAudio(ext) || this.isVideo(ext)) {
        component = (
          <ReactPlayer
            onReady={() => this.setState({ loading: false })}
            onError={() => this.setState({ loading: false })}
            url={file.downloadUrl}
            controls
            width='500px'
          />
        )
      } else {
        component = this.renderNoPreview(lightTheme);
        if (this.state.loading) {
          this.setState({ loading: false });
        }
      }
    }

    return component;
  };

  isImage = (ext = '') => {
    return extensions.previewable.image.includes(ext.toLowerCase())
  };

  isVideo = (ext = '') => {
    return extensions.previewable.video.includes(ext.toLowerCase())
  };

  isAudio = (ext = '') => {
    return extensions.previewable.audio.includes(ext.toLowerCase())
  };

  renderNoPreview = (lightTheme) => (
    <div className={`preview-no-preview ${lightTheme && 'preview-no-preview-light'}`}>
      <h1> No preview available </h1>
    </div>
  );

  render() {
    const file = this.state.preview;
    let link;

    if (file) {
      link = file.downloadUrl;
    }

    const { relative, onHide, lightTheme, hideNavbar, next, back } = this.props;

    return (
      <div
        className={`preview-container${relative ? ' preview-container-relative' : ''} ${lightTheme ? ' preview-container-light' : ''}`}
        onClick={onHide}
      >
        <Row>
          {!hideNavbar &&
            <div className={'preview-navbar'}>
              <h5
                className={'preview-cancel'}
                onClick={onHide}
              >
                <FaTimes/>
              </h5>
            </div>
          }
          <Col
            xs={1}
            sm={1}
            md={1}
            className='preview-icon-container preview-icon-left'
          >
            {back &&
              <p
                onClick={(e) => {
                  e.stopPropagation();

                  back();
                }}
              >
                <FaArrowCircleLeft />
              </p>
            }
          </Col>
          <Col
            xs={10}
            sm={10}
            md={10}
          >
            {this.state.loading &&
            <div className="sk-folding-cube">
              <div className="sk-cube1 sk-cube"></div>
              <div className="sk-cube2 sk-cube"></div>
              <div className="sk-cube4 sk-cube"></div>
              <div className="sk-cube3 sk-cube"></div>
            </div>
            }
            <div className={'preview-inner-container'}>

              {this.renderPreview(file, lightTheme)}

              {file && <h5 className={`preview-title ${lightTheme ? 'preview-title-black' : ''}`}>{file.item}</h5>}
              <div className={'preview-download-button-container'} onClick={e => e.stopPropagation()}>
                <Button download link={link}> Download </Button>
              </div>
            </div>
          </Col>
          <Col
            xs={1}
            sm={1}
            md={1}
            className='preview-icon-container preview-icon-right'
          >
            {next &&
              <p
                onClick={e => {
                  e.stopPropagation();

                  next();
                }}
              >
                <FaArrowCircleRight />
              </p>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  preview: state.preview,
  type: state.type,
});

export default connect(mapStateToProps)(Preview);